import React from 'react';

import { LinkOutSVG } from '../../../../../shared';

export function BannerDescription({ promoLink } = {}) {
  const accentColor = '#73233c';

  return <div className='sertificat__text'>
    <div>
      <p className='sertificat__text__paragraph'>
        Від комедійного горору з Джилліан Андерсон до нових фільмів Павела Павліковського та Мартіна Мак-Дони – 10-й Київський тиждень критики
        представить арт-гіти року у кінотеатрі «Жовтень» з <span style={{ color: accentColor, fontWeight: '700' }}>15 до 21 жовтня</span>. 
      </p>
      <p className='sertificat__text__paragraph'>
        Фільми з Канн, Берліна, Венеції, українська премʼєра стрічки Наталки Ворожбит, <span style={{ fontWeight: '500' }}>український кандидат на «Оскар»</span> та драмеді від Валентина Васяновича — запрошуємо
        дивитися нове актуальне кіно та обговорювати його з професійними кінокритиками після сеансів. 
      </p>

      <p className='sertificat__text__paragraph'>
        <a target="_blank" href={ promoLink } style={{
          color: accentColor,
          fontWeight: '700',
          display: 'flex',
          alignItems: 'center'
        }}>Квитки вже у продажу!<LinkOutSVG color={accentColor} /></a>
      </p>

    </div>
  </div >
}


// WEBPACK FOOTER //
// ./src/components/snippets/ChiefSliderComponent/entities/items/GitaFestival26/impl/BannerDescription/BannerDescription.jsx